<template>
  <section id="contacts" class="relative py-20 md:py-[120px] w-full overflow-hidden">
    <div class="absolute left-0 top-0 -z-[1] h-full w-full " />
    <div class="absolute left-0 top-0 -z-[1] h-2/3 w-full bg-secondary lg:h-1/3 xl:h-[37%]" />
    <div class="container">
      <div class="flex flex-wrap items-center">
        <div class="w-full lg:w-7/12 xl:w-8/12">
          <div class="ud-contact-content-wrapper">
            <div v-motion-slide-visible-once-left :delay="100" class="ud-contact-title mb-12 lg:mb-[150px]">
              <span class="mb-6 block text-base font-medium">
                CONTACT US
              </span>
              <h2 class="max-w-[260px] text-[35px] font-bold leading-[1.14]">
                Let's talk about your problem.
              </h2>
            </div>
            <div class="mb-12 flex flex-wrap justify-between lg:mb-0">
              <div class="mb-8 flex basis-[530px] grow">
                <div class="mr-6 text-[32px] text-primary">
                  <svg width="29" height="35" viewBox="0 0 29 35" class="fill-current">
                    <path d="M14.5 0.710938C6.89844 0.710938 0.664062 6.72656 0.664062 14.0547C0.664062 19.9062 9.03125 29.5859 12.6406 33.5234C13.1328 34.0703 13.7891 34.3437 14.5 34.3437C15.2109 34.3437 15.8672 34.0703 16.3594 33.5234C19.9688 29.6406 28.3359 19.9062 28.3359 14.0547C28.3359 6.67188 22.1016 0.710938 14.5 0.710938ZM14.9375 32.2109C14.6641 32.4844 14.2812 32.4844 14.0625 32.2109C11.3828 29.3125 2.57812 19.3594 2.57812 14.0547C2.57812 7.71094 7.9375 2.625 14.5 2.625C21.0625 2.625 26.4219 7.76562 26.4219 14.0547C26.4219 19.3594 17.6172 29.2578 14.9375 32.2109Z" />
                    <path d="M14.5 8.58594C11.2734 8.58594 8.59375 11.2109 8.59375 14.4922C8.59375 17.7188 11.2187 20.3984 14.5 20.3984C17.7812 20.3984 20.4062 17.7734 20.4062 14.4922C20.4062 11.2109 17.7266 8.58594 14.5 8.58594ZM14.5 18.4297C12.3125 18.4297 10.5078 16.625 10.5078 14.4375C10.5078 12.25 12.3125 10.4453 14.5 10.4453C16.6875 10.4453 18.4922 12.25 18.4922 14.4375C18.4922 16.625 16.6875 18.4297 14.5 18.4297Z" />
                  </svg>
                </div>
                <div class="grow">
                  <h5 class="mb-[18px] text-lg font-semibold">
                    Our Locations
                  </h5>

                  <div class="flex flex-wrap justify-between">
                    <div class="grow basis-[230px]">
                      <p class="text-base text-body-color font-semibold italic">
                        Boston – Main Office
                      </p>
                      <p class="text-base text-body-color mb-8">
                        10 Post Office<br>
                        Square<br>
                        Suite 800<br>
                        Boston, MA 02109
                      </p>

                      <p class="text-base text-body-color font-semibold italic">
                        New York
                      </p>
                      <p class="text-base text-body-color mb-8">
                        745 Fifth Avenue<br>
                        Suite 500<br>
                        New York, NY 10151
                      </p>
                    </div>

                    <div class="grow basis-[230px]">
                      <p class="text-base text-body-color font-semibold italic">
                        Florida
                      </p>
                      <p class="text-base text-body-color mb-8">
                        401 E. Las Olas Blvd<br>
                        Suite 1400<br>
                        Ft. Lauderdale, FL<br>
                        33301
                      </p>

                      <p class="text-base text-body-color font-semibold italic">
                        Washington
                      </p>
                      <p class="text-base text-body-color mb-8">
                        1050 30th Street, NW<br>
                        Washington, D.C. 20007
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-8 flex w-[280px] max-w-full">
                <div class="mr-6 text-[32px] text-primary">
                  <svg width="34" height="25" viewBox="0 0 34 25" class="fill-current">
                    <path d="M30.5156 0.960938H3.17188C1.42188 0.960938 0 2.38281 0 4.13281V20.9219C0 22.6719 1.42188 24.0938 3.17188 24.0938H30.5156C32.2656 24.0938 33.6875 22.6719 33.6875 20.9219V4.13281C33.6875 2.38281 32.2656 0.960938 30.5156 0.960938ZM30.5156 2.875C30.7891 2.875 31.0078 2.92969 31.2266 3.09375L17.6094 11.3516C17.1172 11.625 16.5703 11.625 16.0781 11.3516L2.46094 3.09375C2.67969 2.98438 2.89844 2.875 3.17188 2.875H30.5156ZM30.5156 22.125H3.17188C2.51562 22.125 1.91406 21.5781 1.91406 20.8672V5.00781L15.0391 12.9922C15.5859 13.3203 16.1875 13.4844 16.7891 13.4844C17.3906 13.4844 17.9922 13.3203 18.5391 12.9922L31.6641 5.00781V20.8672C31.7734 21.5781 31.1719 22.125 30.5156 22.125Z" />
                  </svg>
                </div>
                <div>
                  <h5 class="mb-[18px] text-lg font-semibold">
                    How Can We Help?
                  </h5>
                  <p class="text-base text-body-color">
                    info@greenbim.com
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-5/12 xl:w-4/12">
          <div v-motion-slide-visible-once-right :delay="100" class="rounded-lg bg-white px-8 py-10 shadow sm:px-10 sm:py-12 md:p-[60px] lg:p-10 lg:px-10 lg:py-12 2xl:p-[60px]">
            <h3 class="mb-8 text-2xl font-bold md:text-[28px] md:leading-[1.42]">
              Send us a Message
            </h3>
            <form action="https://api.web3forms.com/submit" method="POST">
              <input type="hidden" name="access_key" :value="ACCESS_KEY">
              <div class="mb-[22px]">
                <label for="fullName" class="mb-4 block text-sm text-body-color">Full Name*</label>
                <input type="text" name="fullName" placeholder="Thomas Anderson" class="w-full border-0 border-b border-[#f1f1f1] bg-transparent pb-3 text-body-color placeholder:text-body-color/60 focus:border-primary focus:outline-none ">
              </div>
              <div class="mb-[22px]">
                <label for="email" class="mb-4 block text-sm text-body-color">Email*</label>
                <input type="email" name="email" placeholder="example@yourmail.com" class="w-full border-0 border-b border-[#f1f1f1] bg-transparent pb-3 text-body-color placeholder:text-body-color/60 focus:border-primary focus:outline-none ">
              </div>
              <div class="mb-[22px]">
                <label for="phone" class="mb-4 block text-sm text-body-color">Phone*</label>
                <input type="text" name="phone" placeholder="+885 1254 5211 552" class="w-full border-0 border-b border-[#f1f1f1] bg-transparent pb-3 text-body-color placeholder:text-body-color/60 focus:border-primary focus:outline-none ">
              </div>
              <div class="mb-[30px]">
                <label for="message" class="mb-4 block text-sm text-body-color">Message*</label>
                <textarea ref="textarea" v-model="message" name="message" placeholder="Type your message here" class="w-full resize-none border-0 border-b border-[#f1f1f1] bg-transparent pb-3 text-body-color placeholder:text-body-color/60 focus:border-primary focus:outline-none" />
              </div>
              <div class="mb-0">
                <button type="submit" class="btn-primary">
                  Send
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useTextareaAutosize } from '@vueuse/core';

const { textarea, input: message } = useTextareaAutosize();

const ACCESS_KEY = 'faf82d80-0d1e-40b9-84b3-98935db63372';
</script>
